import { getDevicePlatform } from "./utils-device-category";
import { getValuesWidthAndHeightDefault, getExtraValuesDefault } from "./utils-tv-default";
import { getValuesWidthAndHeightSamsung, getExtraValuesSamsung } from "./utils-tv-samsung";
import {
  getExtraValuesTizen,
  getValuesWidthAndHeightTizen
} from "./utils-tv-tizen";

const platform = getDevicePlatform();
console.log("::::/",platform);

export const getValuesWidthAndHeightTv = (evt: HTMLElement, ribbonHighlight: HTMLElement, target: HTMLElement) => {
  switch (platform) {
    case "samsung":
      return getValuesWidthAndHeightSamsung(evt, ribbonHighlight, target);
    case "tizen":
      return getValuesWidthAndHeightTizen(evt, ribbonHighlight, target);
    default:
      return getValuesWidthAndHeightDefault(evt, ribbonHighlight, target);
  }
}

export const getExtraValuesTv = (evt: HTMLElement, direction: string) => {
  switch (platform) {
    case "samsung":
      return getExtraValuesSamsung(evt, direction);
    case "tizen":
      return getExtraValuesTizen(evt, direction);
    default:
      return getExtraValuesDefault(evt, direction);
  }
};



// WEBPACK FOOTER //
// ./src/components/Focus/utils-to-devices/utils-tv.ts